import { _defineProperty } from "@slyte/core/src/lyte-utils";
import Turbo from "@slyte/component/src/directives/lyte-turbo";
import { SlyteEditorApp } from "./node_modules/@slyte/lyte-editor/addon.js";
import { LyteUiComponentAddon } from "./node_modules/@zoho/lyte-ui-component/addon.js";
import { ZcatUiComponentAddon } from "./node_modules/@zcatalyst/zcat-ui-component/addon.js";
import { Lyte } from "./node_modules/@slyte/core/index.js";
import  {ZcatComponentsDb} from "./data-store/db";
import  {ZcatComponentsComponentRegistry}  from "./components/component";
import  {ZcatComponentsRouter}  from "./router/router";
import $L from "./node_modules/@zoho/lyte-dom/modules/lyte-dom-utils.js";
window.$L = $L;

class ZcatComponentsApp extends Lyte{
    lookups(){
        return [
            SlyteEditorApp,
            LyteUiComponentAddon,
            ZcatUiComponentAddon,
            {component : ZcatComponentsComponentRegistry},
            {router : ZcatComponentsRouter},
            {db : ZcatComponentsDb}
        ];
    }

    _() {
        _;
    }
}

export {ZcatComponentsApp};

ZcatComponentsApp.register({
    hash: "app_1",
    app: true
});

